import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import './index.css';

const ConfirmationModal = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  loading,
  variant,
}) => {
  const confirmBtnClass =
    variant === 'danger'
      ? 'btn btn-danger btn-lg btn-block text-uppercase font-13'
      : 'btn btn-primary btn-lg btn-block btn-color text-uppercase font-13';

  return (
    <Modal className="modal-dialog-centered" isOpen={isOpen} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>{title || 'Confirm'}</ModalHeader>
      <ModalBody>
        <div className="container-fluid">
          <div className="confirmation-modal-message font-13">{message}</div>
          <div className="d-flex justify-content-end mt-4 mb-2">
            <button
              type="button"
              className="btn btn-outline-secondary mr-2 font-13"
              onClick={onCancel}
              disabled={loading}
            >
              {cancelText || 'Cancel'}
            </button>
            <button
              type="button"
              className={confirmBtnClass}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? 'Please wait...' : confirmText || 'Confirm'}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.node.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'danger']),
};

ConfirmationModal.defaultProps = {
  title: 'Confirm',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  loading: false,
  variant: 'default',
};

export default ConfirmationModal;
